import React from 'react';

const Error = () => {
  return (
    <center>
      <img
        src="https://cdni.iconscout.com/illustration/premium/thumb/error-404-4279234-3569464.png"
        alt="Error"
      />
    </center>
  );
};

export default Error;
